module.exports = __webpack_public_path__ + "img/1Reihe_3.0e5f6621.jpg";